<div
  (swipeleft)="onSwipeLeft($event)"
  (swipeRight)="onSwipeRight($event)"
  class="matchSliderFHome"
  [style.width]="windowsWidth * listArray?.length + 'px'"
  [style.margin-left]="positionPX + 'px'"
  [style.height]="'120px'"
  *ngIf="listArray?.length > 0">
  <div class="matchSliderFItem" *ngFor="let i of listArray; let _k = index">
    <div class="item" [style.width]="windowsWidth / countRow + 'px'">
      <div class="heute-main">
        <div class="heute-head">
          <span>
            <ng-container *ngIf="!isLive"
              ><image-loader-utils url="clock" extraClasses="clock-icon"></image-loader-utils> {{ i.MatchTime }}, {{ i.MatchDate | dateFormatDistance }}</ng-container
            >
            <ng-container *ngIf="isLive">{{ 'home_live' | t }} </ng-container>
            <ng-container *ngIf="isLive">{{ i.MatchTime }}{{ i.TimeStatu == '3' ? ' - ' + i.TimeStatuColor : null }}</ng-container>
          </span>
        </div>
        <div class="matchHead" (click)="isLive ? goLiveEventDetail(i.EventId) : goEventDetail(i.MatchId)">
          <div class="itemLine home">
            <span>{{ i.HomeTeam }}</span
            ><span class="score">{{ isLive ? i.Score.split(':')[0] : null }}</span>
          </div>
          <span> - </span>
          <div class="itemLine">
            <span class="score">{{ isLive ? i.Score.split(':')[1] : null }}</span
            ><span>{{ i.AwayTeam }}</span>
          </div>
        </div>

        <p class="oddtypeText">{{ 'tipp' | t }}</p>

        <div class="oddContainer">
          <div [ngClass]="{ tipsContainer: true, wideTips: false }" class="{{ 'itemC0' }} selectPreventer">
            <p (click)="clickOddUP(i['OddId1'], i['OddValue1'] != null && i['OddValue1Visibility'] !== 'hidden')" class="{{ checkOddId(i['OddId1']) }} tipItem itemGr0 w3">
              <!-- ITEM TEXT -->
              <a *ngIf="i['OddValue1'] != null && i['OddValue1Visibility'] !== 'hidden'">
                <span class="gray">1</span>
                <span>{{ i['OddValue1'] | number : '1.2-2' }}</span>
              </a>

              <!-- LOCK -->
              <a *ngIf="i['OddValue1'] == null || i['OddValue1Visibility'] === 'hidden'">
                <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
              </a>
            </p>
            <p (click)="clickOddUP(i['OddId2'], i['OddValue2'] != null && i['OddValue1Visibility'] !== 'hidden')" class="{{ checkOddId(i['OddId2']) }} tipItem itemGr1 w3">
              <!-- ITEM TEXT -->
              <a *ngIf="i['OddValue2'] != null && i['OddValue2Visibility'] !== 'hidden'">
                <span class="gray">x</span>
                <span>{{ i['OddValue2'] | number : '1.2-2' }}</span>
              </a>

              <!-- LOCK -->
              <a *ngIf="i['OddValue2'] == null || i['OddValue2Visibility'] === 'hidden'">
                <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
              </a>
            </p>
            <p (click)="clickOddUP(i['OddId3'], i['OddValue3'] != null && i['OddValue3Visibility'] !== 'hidden')" class="{{ checkOddId(i['OddId3']) }} tipItem itemGr2 w3">
              <!-- ITEM TEXT -->
              <a *ngIf="i['OddValue3'] != null && i['OddValue3Visibility'] !== 'hidden'">
                <span class="gray">2</span>
                <span>{{ i['OddValue3'] | number : '1.2-2' }}</span>
              </a>

              <!-- LOCK -->
              <a *ngIf="i['OddValue3'] == null || i['OddValue3Visibility'] === 'hidden'">
                <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
